<template>
    <div @click="click" class="btn pointer">
       {{ text }}
    </div>
</template>

<script>
export default {
    name: 'XiamenTalentUiButton',
    props:["text"],
    data() {
        return {

        };
    },

    mounted() {

    },

    methods: {
       click(){
            this.$emit("click");
       },
    },
};
</script>

<style lang="less" scoped>
.btn {
    display: inline-block;
    height: 30px;
    padding: 4px 16px;
    box-sizing: border-box;
    border-radius: 4px;
    opacity: 1;
    background: linear-gradient(89.3deg, #50a1fa 0%, #74b7fd 100%);
    box-shadow: 0 2px 0 0 #0000000a;
    opacity: 1;
    color: #ffffff;
    font-size: 16px;
    font-weight: 400;
    font-family: "PingFang SC";
    text-align: center;
    line-height: 22px;
    margin-right: 8px;
}
</style>